import EditableTitle from './EditableTitle';

export default EditableTitle;
export * from './types';
export * from './hooks';
export { EditableTitle };
